import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-608302f5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "push-status-icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_card = _resolveComponent("app-card");
  const _component_app_icon = _resolveComponent("app-icon");
  return $props.loading ? (_openBlock(), _createBlock(_component_app_card, {
    key: 0,
    loading: $props.loading
  }, null, 8, ["loading"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['push-status-btn', $props.statusClass]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClickPushStatusFilter && $options.onClickPushStatusFilter(...args)),
    onMouseover: _cache[1] || (_cache[1] = (...args) => $options.onHover && $options.onHover(...args)),
    onMouseleave: _cache[2] || (_cache[2] = (...args) => $options.onLeave && $options.onLeave(...args))
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_app_icon, {
    icon: $props.icon,
    size: $props.iconSize,
    color: $data.isHovering ? $props.iconHoverColor : $props.iconDefaultColor
  }, null, 8, ["icon", "size", "color"])]), _createElementVNode("div", {
    class: _normalizeClass(['number-result', $props.statusClass])
  }, _toDisplayString($props.pushStatusList?.length), 3), $data.isActivated ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    class: "activatedIcon",
    icon: "product-score-good",
    color: $props.iconDefaultColor
  }, null, 8, ["color"])) : _createCommentVNode("", true)], 34));
}